export const CUSTOMER_DASH_TABLE_COLUMNS = [
    { id: "actions", isSortable: false, label: "Actions" },
    { id: "id", isSortable: false, label: "Customer ID" },
    { id: "name", isSortable: true, label: "Customer Name" },
    { id: "email", isSortable: true, label: "Email" },
    { id: "phone", isSortable: false, label: "Phone Number" },
];